import * as firebase from 'firebase'

export default {
  state: {
    loadedCoordinators: [
      {
        coordinatorId: 'tri',
        coordinatorName: 'Coordinator Sample',
        coordinatorPhone: '123-123-1234',
        coordinatorEmail: 'test@test.com'
      }
    ]
  },
  mutations: {
    setLoadedCoordinators (state, payload) {
      state.loadedCoordinators = payload
    },
    createCoordinator (state, payload) {
      state.loadedCoordinators.push(payload)
    },
    updateCoordinator (state, payload) {
      const coordinator = state.loadedCoordinators.find(coordinator => {
        return coordinator.coordinatorId === payload.coordinatorId
      })
      if (payload.coordinatorName) {
        coordinator.coordinatorName = payload.coordinatorName
      }
      if (payload.coordinatorPhone) {
        coordinator.coordinatorPhone = payload.coordinatorPhone
      }
      if (payload.coordinatorEmail) {
        coordinator.coordinatorEmail = payload.coordinatorEmail
      }
    },
    deleteCoordinator (state, payload) {
      const coordinator = state.loadedCoordinators.find(function (coordinator) {
        return coordinator.coordinatorId === payload.coordinatorId
      })
      var todos = state.loadedCoordinators
      todos.splice(todos.indexOf(coordinator), 1)
    }
  },
  actions: {
    loadCoordinators ({commit}) {
      commit('setLoading', true)
      firebase.database().ref('coordinators').once('value')
        .then((data) => {
          const coordinators = []
          const obj = data.val()
          for (let key in obj) {
            coordinators.push({
              coordinatorId: key,
              coordinatorName: obj[key].coordinatorName,
              coordinatorPhone: obj[key].coordinatorPhone,
              coordinatorEmail: obj[key].coordinatorEmail,
              creatorId: obj[key].creatorId
            })
          }
          console.log(coordinators)
          commit('setLoadedCoordinators', coordinators)
          commit('setLoading', false)
        })
        .catch(
          (error) => {
            console.log(error)
            commit('setLoading', true)
          }
        )
    },
    createCoordinator ({commit, getters}, payload) {
      const coordinator = {
        coordinatorName: payload.title,
        coordinatorPhone: payload.coordinatorPhone,
        coordinatorEmail: payload.coordinatorEmail,
        // coordinatorId: 'alkasjdf', DON'T NEED BECAUSE FIREBASE AUTO GENERATES ID
        icon: 'coordinator_on',
        creatorId: getters.user.id
      }
      firebase.database().ref('coordinators').push(coordinator)
        .then(() => {
          commit('createCoordinator', {
            ...coordinator
          })
        })
        .catch((error) => {
          console.log(error)
        })
      // Reach out to firebase and store it
      // commit('createCoordinator', coordinator)
    },
    // May have to create a separate Action for each updated item (i.e. updateCoordinatorCoordinator, updateCoordinatorDescription, etc)
    updateCoordinatorData ({commit}, payload) {
      commit('setLoading', true)
      const updateObj = {}
      if (payload.coordinatorName) {
        updateObj.coordinatorName = payload.coordinatorName
      }
      if (payload.coordinatorPhone) {
        updateObj.coordinatorPhone = payload.coordinatorPhone
      }
      if (payload.coordinatorEmail) {
        updateObj.coordinatorEmail = payload.coordinatorEmail
      }
      firebase.database().ref('coordinators').child(payload.coordinatorId).update(updateObj)
      .then(() => {
        commit('setLoading', false)
        commit('updateCoordinator', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    },
    deleteCoordinatorData ({commit}, payload) {
      commit('setLoading', true)
      console.log('Payload: ' + JSON.stringify(payload))
      firebase.database().ref('coordinators').child(payload.coordinatorId).remove()
      .then(() => {
        commit('setLoading', false)
        commit('deleteCoordinator', payload)
      })
      .catch(error => {
        console.log(error)
        commit('setLoading', false)
      })
    }
  },
  getters: {
    loadedCoordinators (state) {
      return state.loadedCoordinators.sort((coordinatorA, coordinatorB) => {
        return coordinatorA.date > coordinatorB.date
      })
    },
    featuredCoordinators (state, getters) {
      return getters.loadedCoordinators.slice(0, 5)
    },
    loadedCoordinator (state) {
      return (someId) => {
        return state.loadedCoordinators.find((coordinator) => {
          return coordinator.coordinatorId === someId
        })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/coordinator/index.js